import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumBold,
    CustomLabelMediumRegular,
    CustomLabelSmallBold,
    CustomLabelSmallMedium
} from "../common/CustomLabel";
import Slider from "react-slick/lib";
import Box from "@mui/material/Box/Box";
// import TEAM_MEMBER from "../../assets/images/team-member.png";
import NAEEM from "../../assets/team/naeem.jpg";
import HAMZA from "../../assets/team/hamza.jpg";
import ETHAN from "../../assets/team/ethan.jpg";
import ABDULLAH from "../../assets/team/abdullah.jpg";
import React from "react";
import NorthEastIcon from '@mui/icons-material/NorthEast';
// import Button from "@mui/material/Button/Button";
import {useNavigate} from "react-router-dom"

const teamMembers = [
    { img: HAMZA, name: "Muhammad Hamza", role: "CEO & Co-Founder" },
    { img: NAEEM, name: "Naeeem Qureshi", role: "COO & Co-Founder" },
    { img: ETHAN, name: "Ethan Karian", role: "CBDO & Co-Founder" },
    { img: ABDULLAH, name: "Abdullah", role: "CTO" }
];

const TeamMemberCard = ({ member }) => (
    <div>
        <Grid 
            item 
            direction="column" 
            container 
            alignItems="center"
            sx={{
                padding: { xs: "10px", md: "15px" },
                gap: "12px" 
            }}
        >
            <Grid item>
                <Box
                    component="div"
                    className="zoom-image-container"
                    sx={{
                        width: { xs: "200px", md: "320px" },
                        height: { xs: "200px", md: "400px" },
                        borderRadius: "25px",
                        border: "1px solid #C5C5C5",
                        overflow: "hidden"
                    }}
                >
                    <Box
                        component="img"
                        src={member.img}
                        alt={member.name}
                        className="bw-hover zoom-in"
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover"
                        }}
                    />
                </Box>
            </Grid>
            <Grid item sx={{ mt: 0.5 }}>
                <CustomLabelSmallBold 
                    text={member.name} 
                    color="#5E17EB"
                />
            </Grid>
            <Grid item sx={{ mt: 0.5 }}>
                <CustomLabelSmallMedium 
                    text={member.role}
                />
            </Grid>
        </Grid>
    </div>
);

const ViewAllButton = ({ onClick }) => (
    <Grid item onClick={onClick} >
        <Grid item container sx={{
            border: "1px solid #5E17EB",
            borderRadius: "20px",
            background: "#FFFFFF",
            padding: {xs: "15px 20px", md: "16px 24px"},
            cursor: "pointer"
        }} alignItems="center" justifyContent="center">
            <Grid item>
                <CustomLabelSmallMedium
                    fontWeight="bold"
                    text="View All" 
                    color="#5E17EB"
                />
            </Grid>
            <Grid item sx={{ ml: 1 }}>
                <NorthEastIcon sx={{ color: "#5E17EB" }}/>
            </Grid>
        </Grid>
    </Grid>
);

const MeetOurTeam = ({profile_carousel_settings}) => {
    const navigate = useNavigate();

    // Enhanced slider settings with better mobile handling
    const enhancedSettings = {
        ...profile_carousel_settings,
        touchThreshold: 5,         // More sensitive touch
        swipeToSlide: true,       
        touchMove: true,          
        useCSS: true,             
        useTransform: true,       
        waitForAnimate: true,     // Wait for animation to complete
        dots: false,              // Disable dots for better mobile performance
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,  // Hide arrows on mobile
                }
            }
        ]
    };

    return (
        <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}}} justifyContent="center">
            <Grid item container justifyContent="center" sx={{marginTop: {xs: "20px", md: "50px"}}}>
                <CustomLabelMediumBold text="OUR EXPERTS BEHIND SUCCESS" fontWeight={700} color="#5E17EB"/>
            </Grid>

            <Grid item container xs={10} sx={{ mt: 1 }} justifyContent="center">
                <CustomLabelMediumRegular 
                    normal={false}
                    text="Behind every success is a great team! Get to know the amazing team that makes every project successful."
                />
            </Grid>

            <Grid item xs={12} 
                sx={{
                    padding: {xs: "0px", md: "0px 30px"}, // Removed padding on mobile
                    marginTop: {xs: "20px", md: "40px"},
                    '& .slick-track': {
                        display: 'flex',
                        alignItems: 'center'
                    },
                    '& .slick-slide': {
                        '& > div': {
                            padding: { xs: '0 5px', md: '0 10px' }
                        }
                    }
                }}
            >
                <Box className="slider-container" sx={{ width: '100%', overflow: 'hidden' }}>
                    <Slider {...enhancedSettings}>
                        {teamMembers.map((member, index) => (
                            <TeamMemberCard key={index} member={member} />
                        ))}
                    </Slider>
                </Box>
            </Grid>

            <Grid item container sx={{ mt: 3 }} justifyContent="center">
                <ViewAllButton onClick={() => navigate('/our-team')} />
            </Grid>
        </Grid>
    );
};

// Updated CSS styles
// const styles = `
// .slider-container {
//     width: 100%;
//     overflow: hidden !important;
//     -webkit-tap-highlight-color: transparent;
// }

// .slider-container .slick-list {
//     overflow: visible !important;
//     touch-action: pan-y;
// }

// .slider-container .slick-track {
//     display: flex !important;
//     align-items: center;
// }

// .slider-container .slick-slide {
//     opacity: 1 !important;
//     visibility: visible !important;
//     pointer-events: auto !important;
// }

// @media (max-width: 600px) {
//     .slider-container .slick-slide {
//         padding: 0 5px;
//     }
    
//     .slider-container .slick-list {
//         margin: 0;
//         padding: 0;
//     }
// }
// `;

export default MeetOurTeam;
